import React from 'react';
import {
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  IconButton,
} from '@mui/material';
import {
  FirstPage as FirstPageIcon,
  LastPage as LastPageIcon,
  NavigateBefore as PrevIcon,
  NavigateNext as NextIcon,
} from '@mui/icons-material';
import './styles/DocHubPagination.scss';

const DocHubPagination = ({
  currentPage,
  totalPages,
  totalResults,
  resultsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const rowsPerPageOptions = [10, 25, 50, 100];
  
  // Calculate display range
  const startResult = totalResults === 0 ? 0 : ((currentPage - 1) * resultsPerPage) + 1;
  const endResult = Math.min(currentPage * resultsPerPage, totalResults);
  
  // Handle page navigation
  const handleFirstPage = () => onPageChange(1);
  const handlePrevPage = () => onPageChange(Math.max(1, currentPage - 1));
  const handleNextPage = () => onPageChange(Math.min(totalPages, currentPage + 1));
  const handleLastPage = () => onPageChange(totalPages);
  
  // Handle rows per page change
  const handleRowsChange = (event) => {
    onRowsPerPageChange(event.target.value);
  };
  
  return (
    <Box className="dochub-pagination">
      <Box className="dochub-pagination-info">
        <Typography variant="body2" color="text.secondary">
          Showing {startResult} - {endResult} of {totalResults} results
        </Typography>
      </Box>
      
      <Box className="dochub-pagination-controls">
        <FormControl size="small" className="rows-per-page">
          <Typography variant="body2" component="span" sx={{ mr: 1 }}>
            Rows per page:
          </Typography>
          <Select
            value={resultsPerPage}
            onChange={handleRowsChange}
            variant="standard"
            className="rows-select"
          >
            {rowsPerPageOptions.map(option => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        
        <Box className="page-navigation">
          <IconButton
            size="small"
            onClick={handleFirstPage}
            disabled={currentPage === 1}
            aria-label="First page"
          >
            <FirstPageIcon />
          </IconButton>
          
          <IconButton
            size="small"
            onClick={handlePrevPage}
            disabled={currentPage === 1}
            aria-label="Previous page"
          >
            <PrevIcon />
          </IconButton>
          
          <Typography variant="body2" className="page-info">
            Page {currentPage} of {totalPages}
          </Typography>
          
          <IconButton
            size="small"
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            aria-label="Next page"
          >
            <NextIcon />
          </IconButton>
          
          <IconButton
            size="small"
            onClick={handleLastPage}
            disabled={currentPage === totalPages}
            aria-label="Last page"
          >
            <LastPageIcon />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default DocHubPagination;